/* eslint-disable */
import React, { Component } from "react";
import { createStyles, Theme, withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import Accordion from "@material-ui/core/Accordion";
import { FormControl, FormLabel, Select } from "@chakra-ui/react";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { getRole, updateRole } from "../../utils/store/actions/roles.actions";
import UserHeader from "../../components/Headers/UserHeader";
import { Paper, Switch } from "@material-ui/core";

// reactstrap components
import { Card, CardBody, Row, Col } from "reactstrap";
import { withTranslation } from "react-i18next";

const styles = (theme: Theme) =>
  createStyles({
    paper: {
      backgroundColor: "#F5F6FF",
      maxWidth: "90%",
      margin: "auto",
      overflow: "hidden",
    },
    searchBar: {
      backgroundColor: "#F5F6FF",
      borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
    },
    searchInput: {
      backgroundColor: "#F5F6FF",
      fontSize: theme.typography.fontSize,
    },
    block: {
      display: "block",
    },
    addUser: {
      marginRight: theme.spacing(1),
    },
    contentWrapper: {
      margin: "40px 16px",
    },
    root: {
      flexGrow: 1,
    },
  });

class Role extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      sections: [],
      value: "",
      checkedB: false,
    };
  }
  componentWillMount() {
    const roleId = new URLSearchParams(window.location.search).get("id");
    this.props.getRole(roleId);
  }
  remove_duplicates_es6 = (arr: any) => {
    let s = new Set(arr);
    let it = s.values();
    return Array.from(it);
  };

  getSections = (role: any) => {
    const keys: any = [];
    Object.keys(role).map((key) => {
      let match = key.match(/^(?:[^A-Z]+)/g);
      match && match[0] !== "role" && match[0] !== "id" && keys.push(match[0]);
    });
    return this.remove_duplicates_es6(keys);
  };

  buildSections = (role: any, sections: any) => {
    const keys: any = {};
    sections.map((sec: any) => {
      keys[sec] = [];
      Object.keys(role).map((key, i) => {
        let match = key.match(/^(?:[^A-Z]+)/g);
        match &&
          match[0] === sec &&
          (keys[sec] = [...keys[sec], { key: key, label: role[key] }]);
      });
    });
    return keys;
  };

  handleChange = (role: any, e: any) => {
    this.props.updateRole(
      role,
      [e.target.name],
      e.target.value || e.target.checked
    );
    this.setState({ ...this.state, [e.target.name]: e.target.checked });
    const roleId = new URLSearchParams(window.location.search).get("id");
    this.props.getRole(roleId);
  };
  render() {
    const { classes, Roles, t } = this.props;
    const { role } = Roles;
    let sections: any = [];
    let sectionsContent: any = [];
    if (role) {
      sections = this.getSections(role);
      sectionsContent = this.buildSections(role, sections);
    }
    const { value } = this.state;
    return (
      <div>
        <UserHeader />
        {/* CONTENT */}
        <Paper className={classes.paper}>
          <Row>
            <Col className="order-xl-2 mb-5 mb-xl-0" xl="12">
              <Card className="card-profile shadow">
                <CardBody className="pt-0 pt-md-4">
                  {sections !== [] &&
                    sections.map((sec: any) => (
                      <Accordion key={sec}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                        >
                          <Typography className={classes.heading}>
                            {t(sec.toLowerCase())}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails style={{ display: "block" }}>
                          <Row className="align-items-center">
                            {sectionsContent[sec].map((content: any) => {
                              return (
                                <Col
                                  key={content.key}
                                  className="order-xl-2 mb-5 mb-xl-0"
                                  xl="4"
                                >
                                  <FormControl>
                                    <FormLabel>{t(content.key)}</FormLabel>
                                    {typeof content.label === "boolean" ? (
                                      <Switch
                                        checked={content.label}
                                        onChange={(e: any) =>
                                          this.handleChange(role, e)
                                        }
                                        color="primary"
                                        name={content.key}
                                        inputProps={{
                                          "aria-label": "primary checkbox",
                                        }}
                                      />
                                    ) : (
                                      <Select
                                        bg="white"
                                        name={content.key}
                                        defaultValue={
                                          this.props.Roles.role[content.key]
                                        }
                                        onChange={(e: any) => {
                                          this.handleChange(role, e);
                                        }}
                                      >
                                        <option value="NONE">
                                          {t("NONE")}
                                        </option>
                                        <option value="OWNER_AND_ASSIGNEE_IS_ME">
                                          {t("OWNER_AND_ASSIGNEE_IS_ME")}
                                        </option>
                                        <option value="ASSIGNEE_IS_ME">
                                          {t("ASSIGNEE_IS_ME")}
                                        </option>
                                        <option value="OWNER_IS_ME">
                                          {t("OWNER_IS_ME")}
                                        </option>
                                        <option value="OWNER_IS_IN_MY_GROUP">
                                          {t("OWNER_IS_IN_MY_GROUP")}
                                        </option>
                                        <option value="INVESTOR">
                                          {t("INVESTOR")}
                                        </option>
                                        <option value="OPERATION_IS_IN_MY_FOUND">
                                          {t("OPERATION_IS_IN_MY_FOUND")}
                                        </option>
                                        <option value="ALL">{t("ALL")}</option>
                                      </Select>
                                    )}
                                  </FormControl>
                                </Col>
                              );
                            })}
                          </Row>
                        </AccordionDetails>
                      </Accordion>
                    ))}
                </CardBody>
                <Row className="justify-content-center"></Row>
              </Card>
            </Col>
          </Row>
        </Paper>
      </div>
    );
  }
}

const mapStateToProps = (state: { Roles: RolesState }) => ({
  Roles: state.Roles,
});

const mapDispatchToProps = {
  getRole,
  updateRole,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withStyles(styles)(Role)));
